import { render, staticRenderFns } from "./MlButton.vue?vue&type=template&id=364b48d3&scoped=true&"
import script from "./MlButton.vue?vue&type=script&lang=js&"
export * from "./MlButton.vue?vue&type=script&lang=js&"
import style0 from "./MlButton.vue?vue&type=style&index=0&id=364b48d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b48d3",
  null
  
)

export default component.exports